export default __webpack_public_path__ + "static/media/subsequences-empty.e9abe307.svg";